import { MonitorProgramChangesStepCtrl } from './monitor-program-changes.controller';

export const MonitorProgramChangesStepComponent = {
  controller: MonitorProgramChangesStepCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
    currentCourseDiffs: '<',
  },
  template: require('./monitor-program-changes.html'),
};
